import { render } from "./universalQuotesListing.vue?vue&type=template&id=d9d0c826"
import script from "./universalQuotesListing.vue?vue&type=script&lang=js"
export * from "./universalQuotesListing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__